import { template as template_7744d0b3a9c140368ad528dbedce3f2b } from "@ember/template-compiler";
import { fn } from '@ember/helper';
import RequestValidatedInput from 'client-portal/components/request/validated-input';
import SharedMaskedInput from 'ember-simplepractice/components/shared/masked-input';
import t from 'ember-intl/helpers/t';
export default template_7744d0b3a9c140368ad528dbedce3f2b(`
  <div class="row">
    <div class="col-12" data-test-date-of-birth>
      <label class="required" for="waitlist-date-of-birth">
        {{t "site.waitlistIntake.fields.dateOfBirth"}}
      </label>
      <RequestValidatedInput @model={{@form}} @path="dateOfBirth" @isDirty={{@form.isDirty}}>
        <SharedMaskedInput
          @type="date"
          @value={{@form.dateOfBirth}}
          @onChange={{fn @onUpdate "dateOfBirth"}}
          @inactivePlaceholder={{t "site.waitlistIntake.placeholders.dateOfBirth"}}
          id="waitlist-date-of-birth"
          data-test-date-input
        />
      </RequestValidatedInput>
    </div>
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
